<template>
  <div class="text-2sm text-text-secondary mr-4 whitespace-no-wrap truncate">
    {{ category.title }}
  </div>
</template>

<script>
export default {
  name: "Category",
  props: ['category']
}
</script>

<style scoped>

</style>